import ReactDOM from 'react-dom'
import * as navs from 'scripts/components/navigations/helpers/navItems'
// import RakutenVikiLogo from '../../../../images/logos/rakuten-viki-logo-contrast.svg'

const navigations = {
  en: navs.en,
  es: navs.es
}

function toggleNav(opt, eventData, props) {
  const comp = opt.component
  const dom = ReactDOM.findDOMNode(comp)

  if (props && props.id) {
    if (eventData.id === props.id && eventData.active) {
      if (!dom.classList.contains('navbar-active')) {
        dom.classList.add('navbar-active')

        if (opt.hidden) {
          dom.classList.remove('hidden')
        }
      }
    } else if (eventData.id === props.id && !eventData.active) {
      if (dom.classList.contains('navbar-active')) {
        dom.classList.remove('navbar-active')
      }

      if (!dom.classList.contains('hidden') && opt.hidden) {
        dom.classList.add('hidden')
      }
    }
  }
}

module.exports = {
  navigations,
  toggleNav
}



// WEBPACK FOOTER //
// ./assets/js/components/navigations/helpers/NavigationHelpers.js